@if (this.isCapsLockOn()) {
  <app-shared-notify-chip status="info">
    <ogs-m3-icon prefix="fal" icon="square-arrow-up" />
    <app-shared-notify-chip-value>
      {{"Achtung, die Feststelltaste der Tastatur ist aktiviert!" | translate : "label-caps-lock-notice" : "shared/caps-lock-notice"}}
    </app-shared-notify-chip-value>
  </app-shared-notify-chip>
}

